import { fileApi } from "@/getinfo-api";
import { BaseFile as IBaseFile } from "@/api-v2/files/models";
import { FileList as IFileList } from "@/api-v2/files/models";
import { DirectoryCreate as IDirectoryCreate } from "@/api-v2/files/models";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { SrcDest as ISrcDest } from "@/api-v2/files/models";
import ls, { FileApiLsParams } from "@/getinfo-api/fileManagerLs";
import search, { FileApiSearchParams } from "@/getinfo-api/fileManagerSearch";
import { uniqBy } from "lodash";

let getFolder = (state: any, path: string) => {
  let pathArray = path.split("/").filter((el: any) => el !== ""); // ['folder 1']

  return state.files;
};

export default {
  namespaced: true,
  preserveState: true,
  state: () => ({
    files: [] as Array<any>,
    checkedFiles: [] as Array<any>,
    copiedFiles: [],
    movedFiles: [],
    currentPath: "/",
    diskId: "",
    showSkeletonAmount: 0,
    skeletonItems: false,
    activeTab: 0,
    filesCount: 0
  }),
  actions: {
    async SEARCH_FILES_BY_FILTERS(ctx: any, params: FileApiSearchParams) {
      ctx.state.files = [];
      ctx.state.checkedFiles = [];
      ctx.state.showSkeletonAmount = 5;
      search(params).then((res: { data: any }) => {
        ctx.state.filesCount = 0;
        ctx.commit("SET_FILES", res.data.items);
        ctx.state.showSkeletonAmount = 0;
      });
    },
    async SEARCH_FILE_BY_PATTERN(ctx: any, search: string) {
      if (search && search.length > 2) {
        let str = `*${search}*`;
        ctx.state.files = [];
        ctx.state.checkedFiles = [];
        ctx.state.showSkeletonAmount = 5;
        fileApi.FileApiV2.search(ctx.state.diskId, str).then(
          (res: { data: any }) => {
            ctx.state.filesCount = 0;
            ctx.commit("SET_FILES", res.data.items);
            ctx.state.showSkeletonAmount = 0;
          }
        );
      } else if (!search) {
        ctx.dispatch("GET_DEFAULT_ITEMS");
      }
    },
    GET_DEFAULT_ITEMS(ctx: any) {
      let params = {
        diskId: ctx.state.diskId,
        offset: 0,
        limit: 30,
        sort: "modifiedAt",
        order: "DESC",
        path: ctx.state.currentPath
      };
      ctx.dispatch("CHOOSE_ITEM", params);
    },
    CREATE_FOLDER(ctx: any, title: string) {
      ctx.state.showSkeletonAmount = 1;
      let body: IDirectoryCreate = {
        path: ctx.state.currentPath + `${title}`
      };
      fileApi.FileApiV2.mkdir(ctx.state.diskId, body).then(
        (res: { data: any }) => {
          ctx.commit("ADD_FILES", [res.data]);
          ctx.state.showSkeletonAmount = 0;
        }
      );
    },
    async CHOOSE_ITEM(ctx: any, params: any) {
      ctx.commit("CLEAR_CHECKED_FILES");
      ctx.state.files = [];
      ctx.state.showSkeletonAmount = 5;

      if (params?.diskId) {
        await ls(params).then((res: { data: IFileList }) => {
          ctx.state.filesCount = res.data.count;
          ctx.commit("CHANGE_DIRECTORY", params.path);
          ctx.commit("SET_FILES", res.data.items);
        });
        ctx.state.showSkeletonAmount = 0;
      }
    },
    async UPLOAD_FILE(ctx: any, files: any) {
      ctx.state.showSkeletonAmount = files.length;
      let parallel = async () => {
        await Promise.all(
          files.map(async (file: any) => {
            fileApi.FileApiV2.upload(
              ctx.state.diskId,
              file,
              `${ctx.state.currentPath}${file.name}`
            )
              .then((res: { data: any }) => {
                ctx.commit("ADD_FILES", [res.data]);
              })
              .catch(
                (
                  err: AxiosError<IValidationErrorResponse | IErrorResponse>
                ) => {
                  if (err.response) {
                    ctx.dispatch(
                      "errorException",
                      {
                        vm: this,
                        error: err.response
                      },
                      { root: true }
                    );
                  } else {
                    ctx.dispatch(
                      "localError",

                      `${file.name} не удалось загрузить`,
                      { root: true }
                    );
                  }
                }
              )
              .finally(() => {
                ctx.state.showSkeletonAmount--;
              });
          })
        );
      };
      try {
        await parallel();
      } catch (err) {
        await ctx.dispatch(
          "errorException",
          {
            vm: this,
            error: err.response
          },
          {
            root: true
          }
        );
      }
    },
    REMOVE_FILE(ctx: any, id: string) {
      let file = ctx.getters.GET_FILE(id);
      file.isRemoving = true;
      fileApi.FileApiV2.rm(ctx.state.diskId, [file.path]).then(() => {
        file.isRemoving = false;
        ctx.commit("REMOVE_FILE", id);
      });
    },
    ACCEPT_COPY(ctx: any, path: string) {
      ctx.commit("ACCEPT_COPY", path);
      ctx.commit("CLEAR_COPIED_FILES");
    },
    INIT_DISK(ctx: any, params: FileApiLsParams) {
      ctx.commit("CLEAR_STATE");
      ctx.state.showSkeletonAmount = 5;
      let myParams = params;
      myParams.path = ctx.state.currentPath;

      ls(myParams).then((res: { data: IFileList }) => {
        ctx.state.filesCount = res.data.count;
        ctx.state.files = new Array(res.data.count);
        ctx.commit("SET_FILES", res.data.items);
        ctx.commit("SET_DISK_ID", myParams.diskId);
        ctx.commit("SETUP_PATH", "/");
        ctx.state.showSkeletonAmount = 0;
      });
    },
    async CHANGE_PAGE(ctx: any, params: FileApiLsParams) {
      ctx.state.checkedFiles = [];
      ctx.state.files = [];
      ctx.state.showSkeletonAmount = 5;

      ls(params).then((res: { data: IFileList }) => {
        ctx.state.filesCount = res.data.count;
        ctx.commit("SET_FILES", res.data.items);

        ctx.state.files = uniqBy(ctx.state.files, "id");
        ctx.state.showSkeletonAmount = 0;
      });
    },
    async PASTE_COPY_FILE(ctx: any) {
      ctx.state.showSkeletonAmount = ctx.state.copiedFiles.length;
      let parallel = async () => {
        await Promise.all(
          ctx.state.copiedFiles.map((file: any) => {
            const body: ISrcDest = {
              src: file.path,
              dest: ctx.state.currentPath + file.title
            };
            fileApi.FileApiV2.cp(ctx.state.diskId, body)
              .then((res: { data: IBaseFile }) => {
                ctx.commit("ADD_FILES", [res.data]);
              })
              .catch(e => {
                ctx.dispatch(
                  "errorException",
                  {
                    vm: this,
                    error: e.response
                  },
                  { root: true }
                );
              })
              .finally(() => {
                ctx.state.showSkeletonAmount--;
              });
          })
        );
      };
      try {
        await parallel();
        ctx.commit("CLEAR_COPIED_FILES");
      } catch (e) {
        console.warn(e);
      }
    },
    async PASTE_MOVED_FILE(ctx: any) {
      ctx.state.showSkeletonAmount = ctx.state.movedFiles.length;
      let parallel = async () => {
        await Promise.all(
          ctx.state.movedFiles.map((file: any) => {
            const body: ISrcDest = {
              src: file.path,
              dest: ctx.state.currentPath + file.title
            };
            fileApi.FileApiV2.mv(ctx.state.diskId, body)
              .then((res: { data: IBaseFile }) => {
                ctx.commit("ADD_FILES", [res.data]);
              })
              .catch(e => {
                ctx.dispatch(
                  "errorException",
                  {
                    vm: this,
                    error: e.response
                  },
                  { root: true }
                );
              })
              .finally(() => {
                ctx.state.showSkeletonAmount--;
              });
          })
        );
      };
      try {
        await parallel();
        ctx.commit("CLEAR_MOVED_FILES");
      } catch (e) {
        console.warn(e);
      }
    }
  },
  mutations: {
    SET_ACTIVE_TAB(state: any, tab: number) {
      state.activeTab = tab;
    },
    REMOVE_FILE(state: any, id: string) {
      if (state.currentPath === "/") {
        state.files = state.files.filter((el: any) => el.id !== id);
      } else {
        let index = getFolder(state, state.currentPath)
          .map((el: any) => el.id)
          .indexOf(id);
        getFolder(state, state.currentPath).splice(index, 1);
      }
    },
    COPY_FILE(state: any, file: any) {
      file.type === "File" ? state.copiedFiles.push(file) : null;
      state.copiedFiles = [...new Set(state.copiedFiles)];
    },
    MOVE_FILE(state: any, file: any) {
      file.isRemoving = true;
      state.movedFiles.push(file);
      state.movedFiles = [...new Set(state.movedFiles)];
    },
    CLEAR_STATE(state: any) {
      state.files = [];
      state.copiedFiles = [];
      state.movedFiles = [];
      state.checkedFiles = [];
      state.diskId = "";
      state.currentPath = "/";
    },
    ACCEPT_COPY(state: any, path: string) {
      getFolder(state, path).push(...state.copiedFiles);
    },
    CLEAR_COPIED_FILES(state: any) {
      state.copiedFiles = [];
    },
    CLEAR_MOVED_FILES(state: any) {
      state.movedFiles = [];
    },
    CLEAR_CHECKED_FILES(state: any) {
      state.checkedFiles = [];
    },
    CHANGE_DIRECTORY(state: any, path: string) {
      state.currentPath = path?.length ? "/" + path + "/" : "/";
    },
    SETUP_PATH(state: any, path: string) {
      state.currentPath = path;
    },
    SET_DISK_ID(state: any, id: string) {
      state.diskId = id;
    },
    SET_FILES(state: any, files: Array<IBaseFile>) {
      state.files = [
        ...files.map(el => {
          let arrayPath = el.path.split("/");
          let title = arrayPath[arrayPath.length - 1];
          return {
            ...el,
            child: el.type === "Directory" ? [] : null,
            title: title,
            isRemoving: false
          };
        })
      ];
      state.files = uniqBy(state.files, "id");
    },
    ADD_FILES(state: any, files: Array<IBaseFile>) {
      state.files.unshift(
        ...files.map(el => {
          let arrayPath = el.path.split("/");
          let title = arrayPath[arrayPath.length - 1];
          return {
            ...el,
            child: el.type === "Directory" ? [] : null,
            title: title,
            isRemoving: false
          };
        })
      );
      state.files = uniqBy(state.files, "id");
    },
    ADD_CHECKED_FILE(state: any, file: any) {
      state.checkedFiles.push(file);
      state.checkedFiles = uniqBy(state.checkedFiles, "id");
    },
    REMOVE_FROM_CHECKED_FILE(state: any, file: any) {
      state.checkedFiles = state.checkedFiles.filter(
        (el: any) => el.id !== file.id
      );
    }
  },
  getters: {
    GET_FILES: (state: any) => (type: any = undefined, path: string) => {
      return type
        ? getFolder(state, path).filter((el: any) => el.type === type)
        : getFolder(state, path);
    },

    GET_FILE: (state: any) => (id: string) => {
      return getFolder(state, state.currentPath).find(
        (el: any) => el.id === id
      );
    },

    GET_CURRENT_PATH: (state: any) => {
      return state.currentPath;
    },

    GET_CURRENT_FOLDER: (state: any) => (path: string) => {
      if (path === "/") return state.files;
      return getFolder(state, path);
    },

    GET_DISK_ID: (state: any) => {
      return state.diskId;
    },

    GET_SKELETON: (state: any) => {
      return state.showSkeletonAmount;
    },
    GET_SKELETON_ITEMS: (state: any) => {
      return state.skeletonItems;
    },
    GET_CHECKED_FILES: (state: any) => {
      return state.checkedFiles;
    },
    GET_COPIED_FILES: (state: any) => {
      return state.copiedFiles;
    },
    GET_MOVED_FILES: (state: any) => {
      return state.movedFiles;
    },
    GET_ACTIVE_TAB: (state: any) => {
      return state.activeTab;
    },
    GET_FILES_COUNT: (state: any) => {
      return state.filesCount;
    }
  }
};
